import { useEffect, useState } from 'react';
import {
  Button,
} from "@material-tailwind/react";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/outline';
import useWindowWidth from 'utills/InitWidthDevice';
import { useTranslation } from '@refinedev/core';
import { Breadcrumbs } from 'components/breadcrumbs';
import _ from 'lodash';
import FilterGroup from '../filterGroup';
import Dashboard from '../dashboardList';
import { isHaveActionPermission } from 'utills/helpers';

const WPSRolesList = () => {
  const windowWidth = useWindowWidth();
  const [isMobile, setIsMobile] = useState(false);
  const { translate } = useTranslation();
  const [token, setToken] = useState('');
  const [search, setSearch] = useState({
    q: '',
    status: '',
  } as any);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(true);
  const [applyDate, setApplyDate] = useState({
    start: '',
    end: ''
  });
  const [searchParams] = useSearchParams();
  const paramsObject = Object.fromEntries([...searchParams]);
  const navigate = useNavigate();
  const [initParams, setInitParams] = useState(true);
  const [permissions, setPermissions] = useState(null as any);

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);
      setToken(userData?.token);
    }
  }, []);

  useEffect(() => {
    if (windowWidth && windowWidth < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  const breadcrumbItems = [
    {
      label: translate('organization'),
      href: ''
    },
    {
      label: translate('role-management'),
      href: ''
    },
  ];

  useEffect(() => {
    if (initParams) {
      const keys = Object.keys(paramsObject);

      if (keys?.length > 0) {
        handleInitSearchValue();
      } else {
        setFilter(true);
        setInitParams(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initParams]);

  const handleInitSearchValue = () => {
    const searchTemp = _.cloneDeep(search);

    if (paramsObject.q && paramsObject.q !== '') {
      searchTemp.q = paramsObject.q;
    }

    if (paramsObject.status && paramsObject.status !== '') {
      searchTemp.status = paramsObject.status;
    }

    if (paramsObject.gte && paramsObject.gte !== '') {
      setApplyDate({
        start: paramsObject.gte,
        end: paramsObject.lte
      })
    }

    setSearch(searchTemp);

    const intervalInit = setInterval(() => {
      setFilter(true);
      setInitParams(false);
      clearInterval(intervalInit);
    }, 1000);

  }

  useEffect(() => {
    handleUpdateRoute();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, applyDate]);

  const handleUpdateRoute = () => {
    const newSearchParams = new URLSearchParams(searchParams);

    newSearchParams.set('q', search.q);
    newSearchParams.set('status', search.status);
    newSearchParams.set('gte', applyDate.start);
    newSearchParams.set('lte', applyDate.end);

    const newParamsObject = Object.fromEntries([...newSearchParams]);

    const keys = Object.keys(newParamsObject);
    let changeRoute = false;

    if (keys?.length > 0) {
      keys?.forEach((key: string) => {
        if (newParamsObject[key] !== '') {
          changeRoute = true;
        }
      });
    }

    if (changeRoute || !initParams) {
      navigate(`?${newSearchParams.toString()}`, { replace: true });
    }
  }

  useEffect(() => {
    const user = localStorage.getItem("USER");

    if (user) {
      const userData = JSON.parse(user);

      if (userData?.type === 'wps') {
        const roles = [] as any;
        setToken(userData?.token);

        userData.permissions.forEach((item: any) => {
          const obj = {
            id: (item.resource !== "") ? item.resource : item.app,
            permissions: item.action,
            parrent: item.app
          };

          roles.push(obj);

          setPermissions(roles);

        });
      }
    }
  }, [windowWidth]);

  return (
    <div className="w-full">
      <Breadcrumbs
        type="wps"
        breadcrumbItems={breadcrumbItems}
        disableBorder={true}
        additionalLabel={
          <div className="flex items-center gap-x-4">
            {isMobile && (
              <FilterGroup
                translate={translate}
                search={search}
                setSearch={setSearch}
                setFilter={setFilter}
                setApplyDate={setApplyDate}
                setPage={setPage}
                applyDate={applyDate}
                isMobile={isMobile}
              />
            )}

            {isMobile ? (
              <>
                {isHaveActionPermission(
                  "role",
                  "organization",
                  "create",
                  permissions
                ) && (
                  <Link to="/organization/role/create">
                    <div className="size-[48px] flex items-center justify-center bg-brand-500 rounded-[8px]">
                      <PlusIcon
                        className="size-[16px] text-white"
                        strokeWidth={3}
                      />
                    </div>
                  </Link>
                )}
              </>
            ) : (
              <>
                {isHaveActionPermission(
                  "role",
                  "organization",
                  "create",
                  permissions
                ) && (
                  <Link to="/organization/role/create">
                    <Button
                      onPointerEnterCapture="none"
                      onPointerLeaveCapture="none"
                      onResize={() => {}}
                      onResizeCapture={() => {}}
                      placeholder="btn-create"
                      className="btn-create-accounh-[48px] flex items-center justify-center gap-[8px] bg-brand-500"
                    >
                      <PlusIcon
                        className="size-[16px] text-white"
                        strokeWidth={3}
                      />

                      <span className="text-white text-14 font-700">
                        {translate("create-new-role")}
                      </span>
                    </Button>
                  </Link>
                )}
              </>
            )}
          </div>
        }
      />

      <div className="w-full" id="role-management">
        <div className="w-full p-[16px] grid grid-cols-1 gap-[16px]">
          {!isMobile && (
            <FilterGroup
              translate={translate}
              search={search}
              setSearch={setSearch}
              setFilter={setFilter}
              setApplyDate={setApplyDate}
              setPage={setPage}
              applyDate={applyDate}
              isMobile={isMobile}
            />
          )}

          <Dashboard
            translate={translate}
            search={search}
            setSearch={setSearch}
            filter={filter}
            setFilter={setFilter}
            applyDate={applyDate}
            setPage={setPage}
            page={page}
            isMobile={isMobile}
            token={token}
            permissions={permissions}
          />
        </div>
      </div>
    </div>
  );
};

export default WPSRolesList;